module.exports = __webpack_public_path__ + "static/media/thailand.b7c56b4f.svg";